import { GsbProperty } from './gsb-entity-def.model';
import { GsbModule } from './gsb-module.model';

export class GsbCodeGenerator { 
    _entDefName?: string;
    public id?: string;
    public day?: boolean;
    public properties?: GsbProperty[];
    public month?: boolean;
    public text?: string;
    public name?: string;
    public year?: boolean;
    public module?: GsbModule;
    public digits?: number;
    public module_id?: string;
    public title?: string;
    public lastUpdateDate?: Date;
    public lastIndex?: number;

    constructor(obj?: Partial<GsbCodeGenerator>) {
        Object.assign(this, obj);
        this._entDefName = "GsbCodeGenerator";
    }
} 